const FoodJournalRoutes = [
  {
    path: "/food-journal",
    name: "FoodJournal",
    component: () => import("@/pages/FoodJournal/DailyFoodJournalPage.vue"),
    meta: {
      title: "Food Journal"
    }
  },
  {
    path: "/food-journal/week/:date?",
    name: "FoodJournalWeek",
    component: () => import("@/pages/FoodJournal/WeeklyFoodJournalPage.vue"),
    props: true,
    meta: {
      title: "Weekly Food Journal"
    }
  },
  {
    path: "/food-journal/:date",
    name: "FoodJournalDate",
    component: () => import("@/pages/FoodJournal/DailyFoodJournalPage.vue"),
    props: true,
    meta: {
      title: "Food Journal"
    }
  },
  {
    path: "/clients/:userId/food-journal",
    name: "CoachClientFoodJournal",
    component: () => import("@/pages/FoodJournal/DailyFoodJournalPage.vue"),
    props: true,
    meta: {
      title: "Client Food Journal",
      requireCoach: true
    }
  },
  {
    path: "/clients/:userId/food-journal/week/:date?",
    name: "CoachClientFoodJournalWeek",
    component: () => import("@/pages/FoodJournal/WeeklyFoodJournalPage.vue"),
    props: true,
    meta: {
      title: "Client Weekly Food Journal",
      requireCoach: true
    }
  },
  {
    path: "/clients/:userId/food-journal/:date",
    name: "CoachClientFoodJournalDate",
    component: () => import("@/pages/FoodJournal/DailyFoodJournalPage.vue"),
    props: true,
    meta: {
      title: "Client Food Journal",
      requireCoach: true
    }
  }
];

export default FoodJournalRoutes;
